<template>
  <div>
    <div class="row justify-center">
      <div class="col-12 col-md-10">
        <h1 class="text-center fz-32 fw-700">
          Sistem Lapor Jual Kendaraan Bermotor
        </h1>

        <br />
        <br />

        <div class="row stepper">
          <div
            v-for="(item, index) in Stepper"
            :key="index"
            class="mb-3 mb-md-0 col-12 col-md-6 col-lg-3"
          >
            <div
              :class="
                index <= stepperActive ? 'stepper-item active' : 'stepper-item'
              "
            >
              <span>{{ index + 1 }}. {{ item }}</span>
            </div>
          </div>
        </div>

        <br />
        <br />

        <DataKendaraan v-if="stepperActive == 0" />
        <InfoKendaraan v-else-if="stepperActive == 1" />
        <VerifikasiData v-else-if="stepperActive == 2" />
        <konfirmasiPelaporan v-else />
      </div>
    </div>

    <br />
    <br />
    <br />

    <div class="d-flex justify-end">
      <router-link to="/panduan" class="text-black">
        Lihat Panduan ->
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainScreen",
  components: {
    DataKendaraan: () => import("@/views/MainScreen/Step/1-DataKendaraan"),
    InfoKendaraan: () => import("@/views/MainScreen/Step/2-InfoKendaraan"),
    VerifikasiData: () => import("@/views/MainScreen/Step/3-VerifikasiData"),
    konfirmasiPelaporan: () =>
      import("@/views/MainScreen/Step/4-konfirmasiPelaporan"),
  },
  data() {
    return {
      Stepper: [
        "Data Kendaraan",
        "Info Kendaraan",
        "Verifikasi Data",
        "Konfirmasi Pelaporan",
      ],
    };
  },
  computed: {
    stepperActive: {
      get() {
        return this.$store.state.main.stepperActive;
      },
      set(value) {
        this.$store.commit("SET_STEPPER_ACTIVE", value);
      },
    },
  },
  methods: {},
};
</script>
